'use strict';

DoohApps
.factory('AccessRightsData', ['restApi', function (restApi) {
    var controllerName = 'Company/';

    return {
        getAccessRights: function (successCallback, roleID) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetAccessRights?roleID='+ roleID);
        },
    }
}]);